import { Grid } from "@mui/material";
import CustomSelect from "../../../../../../../../components/CustomSelect";
import Input from "../../../../../../../../components/Input";
import { PatientVital } from "../../../../../../../../services";
import { PULSE_RATE_OPTS, VitalFormik } from "../vital-constant";

interface PulseRateFieldsProps {
  formik: VitalFormik;
  ind: number;
}

const PulseRateFields = ({ formik, ind }: PulseRateFieldsProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  const selectHandleChange = (k: keyof PatientVital, v: string | null) => {
    formik.setFieldValue(getKey(k), v);
  };

  return (
    <Grid
      container
      sx={{
        gap: 2,
      }}
    >
      <Grid size={1.8}>
        <Input
          required={isSelected}
          error={getError("value")}
          textFieldProps={{
            name: getKey("value"),
            placeholder: "24.9",
            value: activeVital?.value,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
          }}
        />
      </Grid>
      <Grid size={2.6}>
        <CustomSelect
          name={getKey("method")}
          placeholder="Regular"
          options={PULSE_RATE_OPTS}
          value={activeVital?.method}
          onChange={(v) => selectHandleChange("method", v)}
        />
      </Grid>
    </Grid>
  );
};

export default PulseRateFields;
